<h3 class="text-center mb-3" class="message">{{responseMeaasge}}</h3>
<div class="text-center">
    <button class="btn ok-btn btn-primary" (click)="closeModal()">Ok</button>
</div>